import React, {Component} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './income-chart.scss';

am4core.useTheme(am4themes_animated);

export default class IncomeChart extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }
  componentDidMount () {
    const chart = am4core.create('incomeChart', am4charts.PieChart);

    const pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.colors.list = [
      am4core.color('#315634'),
      am4core.color('#608b5d'),
      am4core.color('#95bc92'),
      am4core.color('#b9ecb5')
    ];

    pieSeries.dataFields.value = 'litres';
    pieSeries.dataFields.category = 'country';

    pieSeries.slices.template.stroke = am4core.color('#ddd');
    pieSeries.slices.template.strokeWidth = 1;
    pieSeries.slices.template.strokeOpacity = 1;
    pieSeries.slices.template.cursorOverStyle = [
      {
        property: 'cursor',
        value: 'pointer'
      }
    ];

    pieSeries.alignLabels = false;
    pieSeries.labels.template.disabled = true;
    // pieSeries.labels.template.radius = 3;
    // pieSeries.labels.template.padding(1, 1, 1, 1);
    pieSeries.labels.template.fill = am4core.color('#fff');

    pieSeries.ticks.template.disabled = true;

    // Create a base filter effect (as if it's not there) for the hover to return to
    const shadow = pieSeries.slices.template.filters.push(
      new am4core.DropShadowFilter()
    );
    shadow.opacity = 0;

    // Create hover state
    const hoverState = pieSeries.slices.template.states.getKey('hover'); // normally we have to create the hover state, in this case it already exists

    // Slightly shift the shadow and make it more prominent on hover
    const hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
    hoverShadow.opacity = 0.7;
    hoverShadow.blur = 5;

    // Add a legend
    // pieSeries.legendSettings.itemValueText ='[]{value}'

    chart.legend = new am4charts.Legend();
    chart.legend.position = 'bottom';
    chart.legend.labels.template.fill = am4core.color('#fff');
    chart.legend.fontSize = 12;
    const marker = chart.legend.markers.template.children.getIndex(0);
    marker.cornerRadius(12, 12, 12, 12);
    chart.legend.valueLabels.template.fill = am4core.color('#fff');
    chart.legend.itemContainers.template.clickable = false;
    chart.legend.itemContainers.template.focusable = false;
    chart.legend.labels.template.text = '{name}';
    chart.legend.labels.template.valueText = 'd';
    chart.legend.itemContainers.template.cursorOverStyle =
      am4core.MouseCursorStyle.default;

    chart.data = [
      {
        country: '<$15K',
        litres: 501.9
      },
      {
        country: '$15K-$25K',
        litres: 165.8
      },
      {
        country: '$25-$35K',
        litres: 139.9
      },
      {
        country: '$50-$75K',
        litres: 128.3
      }
    ];

    this.chart = chart;
  }
  UNSAFE_componentWillReceiveProps (nextProps) {

    if (nextProps.currentFeature) {

      const feat = nextProps.currentFeature.attributes.income;
      const data = [
        {
          country: '<$25K',
          litres: feat.income_low
        },
        {
          country: '$25K-$50K',
          litres: feat.income_midlow
        },
        {
          country: '$50-$100K',
          litres: feat.income_midhigh
        },
        {
          country: '$100K+',
          litres: feat.income_high
        }
      ];
      this.chart.data = data;
    }
  }
  render () {
    return <div id="incomeChart" onClick={() => {
      this.props.onWidget();
    }}></div>;
  }
}
